// extracted by mini-css-extract-plugin
module.exports = {"root":"Board_root__30gjT","container":"Board_container__mBpoF"};